import { useEffect, useState } from 'react';
import { displayName, useStore } from '../store';

export function TypingIndicator({
  channelId,
  guildId,
  extra = [],
}: {
  channelId: string;
  guildId: string | null;
  extra?: string[];
}) {
  const typing = useStore((s) => s.typing[channelId]);
  const meId = useStore((s) => s.me?.id);
  const [, tick] = useState(0);
  useEffect(() => {
    const t = window.setInterval(() => tick((n) => n + 1), 2000);
    return () => window.clearInterval(t);
  }, []);
  const now = Date.now();
  const ids = [
    ...new Set([
      ...Object.entries(typing ?? {})
        .filter(([id, until]) => until > now && id !== meId)
        .map(([id]) => id),
      ...extra,
    ]),
  ];
  const names = ids.map((id) => displayName(useStore.getState(), id, guildId));
  const text =
    names.length === 0
      ? ''
      : names.length === 1
        ? `${names[0]} is typing…`
        : names.length <= 3
          ? `${names.join(', ')} are typing…`
          : 'Several people are typing…';
  return <div className="h-5 px-4 text-xs font-medium text-text-2">{text}</div>;
}
